import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Gift, X } from "lucide-react";
import { currentGiftSeason } from "@/lib/books";

const KEY = "mm_gift_banner_dismissed";
const COVER = "https://customer-assets-lxgj4vgw.emergentagent.net/job_swim-mastery-2/artifacts/57a027a30a514f1e_8C9D4A39-A885-4DD0-AA1D-2264F27E3189.webp";

export const GiftBanner = () => {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => window.scrollY > 700 && setScrolled(true);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const season = currentGiftSeason();
  const show = scrolled && !hidden && !pathname.startsWith("/swim-books") && !pathname.startsWith("/admin");

  const dismiss = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }} transition={{ duration: 0.6 }}
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-40 rounded-2xl text-white flex items-center gap-4 p-4 pr-10"
          style={{ backgroundColor: "var(--navy)", boxShadow: "0 20px 50px rgba(11,27,61,0.35)" }}
          data-testid="gift-banner"
        >
          <img src={COVER} alt="" aria-hidden className="w-14 h-[72px] object-cover rounded-md shrink-0" style={{ boxShadow: "-3px 0 0 #D4AF37" }} />
          <div className="min-w-0">
            <p className="font-body text-[10px] tracking-[0.2em] uppercase flex items-center gap-1.5" style={{ color: "var(--gold)" }} data-testid="gift-banner-tag">
              <Gift size={12} /> {season.tag}
            </p>
            <p className="font-display text-lg leading-snug mt-1" data-testid="gift-banner-title">{season.title}</p>
            <Link to="/swim-books?gift=1#book-request" className="inline-block font-body text-xs mt-2 underline underline-offset-4 decoration-[var(--gold)] hover:opacity-80" data-testid="gift-banner-cta">
              Request a gift book
            </Link>
          </div>
          <button onClick={dismiss} aria-label="Close" className="absolute top-3 right-3 text-white/60 hover:text-white" data-testid="gift-banner-close"><X size={16} /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
